import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedPrivileges?: string[];
  allowedRoles?: string[];
}

const ProtectedRoute = ({
  children,
  allowedPrivileges,
  allowedRoles,
}: ProtectedRouteProps) => {
  const sessionUid = localStorage.getItem("session_uid");
  const privilege = localStorage.getItem("privilege") || "";
  const userRole = localStorage.getItem("user_role") || "";
  const location = useLocation();


  const [hydrated, setHydrated] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => setHydrated(true), 50);
    return () => clearTimeout(timer);
  }, []);

  if (!hydrated) {
    console.log("⏳ ProtectedRoute waiting for hydration...");
    return null;
  }

  const isInitialLogin = localStorage.getItem("mapp_consent") === "false";

  // console.log("🔐 ProtectedRoute check", {
  //   path: location.pathname,
  //   sessionUid,
  //   isInitialLogin,
  // });

  // 1No session → must login
  if (!sessionUid) {
    return <Navigate to="/login" replace />;
  }

  // If still initial login → force /app-download (unless already there)
  if (isInitialLogin && location.pathname !== "/app-download") {
    return <Navigate to="/app-download" replace />;
  }

  // If initial login is false but user manually visits /app-download → send them home
  if (isInitialLogin && location.pathname === "/app-download") {
    return <Navigate to="/home" replace />;
  }

  // Optional privilege/role check
  const hasPrivilege = !allowedPrivileges || allowedPrivileges.includes(privilege);
  const hasRole = !allowedRoles || allowedRoles.includes(userRole);
  if (!hasPrivilege || !hasRole) {
    return <Navigate to="/home" replace />;
  }


  return <>{children}</>;
};

export default ProtectedRoute;
